<template>
  <div class="l-shop-deal bg-white pb-38">
    <!-- list new -->
    <ul class="c-list-deal c-list-deal--xl has-full" v-show="!loading">
      <li>
        <div class="c-list-deal__item">
          <template v-if="news.image && news.image.length > 0">
            <div class="swiper-container js-swiper_tab_body-news">
              <div class="swiper-wrapper">
                <div class="c-list-deal__img swiper-slide js-keep-ratio" data-ratio="0.746" v-for="(img, index) in news.image" :key="img + index">
                  <img v-lazy="getImgSrc(img)" alt="">
                </div>
              </div>
            </div>
          </template>
          <div v-else>
            <div class="c-list-deal__img js-keep-ratio" data-ratio="0.746">
              <img src="/assets/images/aeontown-noimg.png" alt="">
            </div>
          </div>
          <div class="swiper-pagination swiper-pagination-newsdetail" v-if="news.image && news.image.length > 1"></div>

          <div class="c-list-deal__info">
            <div class="c-list-deal__info--head mb-12">
              <div class="c-list-deal__info--time">
                <span v-if="news.discloseAt">掲載日：{{ formatDateTime(news.discloseAt) }}</span>
              </div>
              <favorite-icon
                :isActive="isActive(news.id)"
                :toggleFavorite="() => toggleFavoriteNews(news)"
              />
            </div>
            <div>
              <div class="mb-12 news-title">{{ news.title }}</div>
              <div class="c-list-deal__shop">
                <div v-if="news.provider" class="c-list-deal__shop--img"><router-link :to="`/shop/list?id=${news.provider.id}`"><img v-lazy="getImgSrc(news.provider.image[0])" alt=""></router-link></div>
                <div v-if="news.provider" class="c-list-deal__shop--name"><router-link :to="`/shop/list?id=${news.provider.id}`">{{ news.provider.shopName }}</router-link></div>
              </div>
            </div>
            <div class="c-list-deal__info--content">
              <div v-html="autolink(news.content)"></div>
            </div>
            <div class="pb-50">
              <div v-on:click="backList" class="btn-outline center-all-item btn-to-site">戻る</div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <loader :loading="loading" />
    <alert :message="alert_msg" :show="alert_show" :closeModal="closeModal" :confirm_show="confirm_show"
        :confirm_message="confirm_msg" :confirm_callback="confirm_callback" :confirm_hide_cancel="confirm_hide_cancel"
        :label_cancel="confirm_label_cancel" :label_ok="confirm_label_ok"></alert>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Swiper, { Pagination } from "swiper";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { getNews, getShop } from "../store/firestore.js";
import { NEW_COLLECTION_KEY } from "../config/const.js";
import loader from "../components/parts/loader.vue"
import FavoriteIcon from "../components/FavoriteIcon.vue";
import Alert from "../components/Alert.vue";
const $ = window.$;

Swiper.use(Pagination);

export default Vue.extend({
  name: "NewsDetail",
  props: {
    newsId: {
      type: String,
      required: false
    },
    newsProviderId: {
      type: String,
      required: false
    },
    toggleFavoriteNews: {
      type: Function,
      required: true
    },
    isActive: {
      type: Function,
      required: true
    }
  },
  components: {
    FavoriteIcon,
    loader,
    alert: Alert
  },
  mixins: [Tenant],
  watch: {
    newsId: {
      handler: async function (newVal) {
        if (!newVal) return
        this.loading = true
        let shopId = Common.getUrlParam('shopId');
        if(!shopId || shopId === this.$store.state.shopId){
          await this.getNewsData()
        }
        if (this.swiper) this.swiper.destroy()
        this.swiper = new Swiper(".js-swiper_tab_body-news", {
          slidesPerView: 1,
          speed: 400,
          direction: "horizontal",
          observer: true,
          observeParents: true,
          waitForTransition: true,
          pagination: {
            el: ".swiper-pagination-newsdetail",
            clickable: true,
          },
        });
      },
      immediate: true
    }
  },
  data() {
    return {
      isAndroid: Common.isAndroid(),
      news: {},
      categoryContent: '',
      categoryColor: '',
      NEW_COLLECTION_KEY: NEW_COLLECTION_KEY,
      loading: false,
      swiper: null
    }
  },
  async created() {
    // pushからのshopId付きの起動
    const shopId = Common.getUrlParam('shopId');
    if (shopId && shopId != this.$store.state.shopId) {
      const shop = await getShop(shopId);
      const res = await this.confirm(`${shop.name}\n\nこの店舗に表示を切り替える`, false, { ok_label: 'はい', cancel_label: 'いいえ' });
      if (res) {
        await this.$store.dispatch('setShopId', shopId);
        location.reload()
      } else {
        this.$router.push('/top');
      }
    }
    if (!this.readNewsExists(this.newsId)) {
      this.addRead(this.news, NEW_COLLECTION_KEY, this.news.provider);
    }
    $('.c-list-deal__info--content a').addClass('ext-link');
  },
  computed: {
    imageScale: function () {
      const scale = window.screen.width / 2250;
      console.log(scale);
      return scale;
    }
  },
  mounted() {
    Common.initDom();
  },
  updated() {
    this.$nextTick(function () {
      Common.setKeepRatio()
    })
  },
  methods: {
    async getNewsData() {
      if (!this.newsId) return
      this.loading = true
      this.news = await getNews(this.newsId, this.newsProviderId)
      this.loading = false
      // Firebase analytics 
      // { tenantId: "テナントID", shopId: "SC ID" }
      Common.analyticsLogEvent('access_shoparticle', {
        tenantId: this.newsProviderId,
        newsId: this.newsId,
        shopId: this.SHOP_ID,
      });
    },
    backList() {
      this.$emit('navigateBack');
    },
  },
})
</script>
